// extracted by mini-css-extract-plugin
export default {"reset":"PqwQUp","visuallyHidden":"G_IV4Z"};